














































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import { TransportUnit } from "../models";

@Component
export default class UnitSelect extends Vue {
    @Prop() units!: TransportUnit[];
    @Prop() value!: TransportUnit[];

    showAll = false;

    // Vue seems to do overaggressive component reuse, hence this is needed
    @Watch("units")
    unitsChanged() {
        this.showAll = false;
    }

    get internalValue(): TransportUnit[] {
        return this.value;
    }

    set internalValue(value: TransportUnit[]) {
        this.$emit("input", value);
    }
}
